import React from "react";
import { Paper } from "@mui/material";
import IdCardRenderer from "./components/IdCardRenderer";

const StudentIdCardPreview: React.FC<{ html: string }> = ({ html }) => {
  return (
    <Paper sx={{ p: 2, display: 'flex', justifyContent: 'center', background: '#f5f5f5', minHeight: '300px', alignItems: 'center' }}>
      <IdCardRenderer html={html} />
    </Paper>
  );
};

export default StudentIdCardPreview;
